<template>
    <div id="changePwd">
        <!-- <div class="login-text">
               <p class="p_p_p">系统检测您的账号安全性较低. 请修改您的密码!</p>
            </div> -->
        <div class="form-pwd">
            <label for="">旧密码 : </label>
            <input type="text" style="display: none;">
            <input type="password" style="display: none;">
            <input type="text" name="text" placeholder="填写原密码" v-model="oldPwd">

        </div>
        <div class="form-pwd">
            <label for="">新密码 : </label>

            <input type="password" name="pwd" placeholder="填写新密码" v-model="newPwd">

        </div>
        <div class="form-pwd">
            <label for="">确认密码 : </label>
            <input type="password" name="pwd" placeholder="再次填写密码" v-model="reNewPwd">

        </div>
        <div class="form-pwd">
            <p v-if="message"> {{ message }}</p>

        </div>
        <div class="ft-btn flex flex-pack-center">
            <button type='button' class="u-btn w100 avtive" :class='classText' @click="onSubmit">完成</button>
        </div>

        <div class="bottom-wrapper">
            <div class="nav-bottom flex flex-pack-around">
                <router-link :to="{ name: 'Home' }">
                    <i class="iconfont icon-back"></i>
                </router-link>
                <router-link :to="{ name: 'Home' }">
                    <i class="iconfont icon-home"></i>
                </router-link>
            </div>
        </div>
    </div>
</template>
<script>
import { Indicator } from 'mint-ui'
export default {
    data() {
        return {
            oldPwd: null,
            newPwd: null,
            reNewPwd: null,
            message: "密码需包含字母+不连续数字组合，且大于6位小于20位，不可有空格。",
            btnClick: true,
            classText: '',
            userId: this.$route.query.userId,
            pattrn: /[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/
        }
    },
    watch: {
        // "oldPwd": function() {
        //     this.btnClick = this.oldPwd && this.newPwd && this.reNewPwd ? false: true;
        //     this.classText = this.oldPwd && this.newPwd && this.reNewPwd? 'avtive': '';
        // },
        // "newPwd": function() {
        //     this.btnClick = this.oldPwd && this.newPwd && this.reNewPwd? false: true;
        //     this.classText = this.oldPwd && this.newPwd && this.reNewPwd? 'avtive': '';
        // },
        // "reNewPwd": function() {
        //     this.btnClick = this.oldPwd && this.newPwd && this.reNewPwd? false: true;
        //     this.classText = this.oldPwd && this.newPwd && this.reNewPwd? 'avtive': '';
        // }
    },
    methods: {
        onSubmit() {

            if (!this.oldPwd) {
                this.message = "请输入旧密码";
                return false
            }
            if (!this.newPwd) {
                this.message = "请输入新密码";
                return false
            }

            if (this.newPwd !== this.reNewPwd) {
                this.message = "两次密码不一致";
                return false
            }
            if (!this.pattrn.test(this.newPwd)) {
                this.message = "密码必须包含字母和数字";
                return false;
            } else if (this.newPwd.length < 6 || this.newPwd.length > 20) {
                this.message = "请输入6-20位字母和数字的密码";
                return false;
            }

            this.$http.get('api/admin/user/pwdChange', {
                params: {
                    oldPwd: this.oldPwd,
                    newPwd: this.newPwd,
                    confirmPwd: this.reNewPwd,
                    userId: this.userId
                }
            }).then(suss => {

                if (suss.data.flag) {
                    this.message = null;
                    Indicator.open('修改成功');
                    setTimeout(() => {
                        Indicator.close();
                        this.$router.push({ path: "/login" })
                    }, 700);
                } else {
                    this.message = suss.data.message;
                }

            })
        }
    },
    mounted() {

    }
}
</script>
<style>
.p_p_p {

    width: 100%;
    text-align: center;
    font-size: 14px;
    color: #ccc;
    font-weight: 400;
}

#changePwd .ft-btn {
    margin-top: 35px;
    ;
}

#changePwd input {
    width: 60%;
    border-bottom: 1px solid #ccc;
}

#changePwd .form-pwd:after {
    border: none;
}

#changePwd .form-pwd label {
    display: inline-block;

    width: 75px;
}

#changePwd .avtive {
    background: #43ca92;
    color: white;
}

.form-pwd p {
    color: red;
    text-align: center;
    font-size: 14px;
}</style>




// WEBPACK FOOTER //
// src/components/user/changePwd.vue